<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-form ref="MPORSummary" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header">
            <div class="dialog-header-content">
              <div class="dialog-title-wrapper">
                <div class="dialog-icon">
                  <icon name="global-icon" />
                </div>

                <div class="dialog-text">
                  <div class="dialog-title">
                    Summary of Accomplishment ({{ monthRange }})
                  </div>

                  <div class="dialog-subtitle">
                    Review and monitor completed accomplishments and performance
                    achievements for the selected period.
                  </div>
                </div>
              </div>

              <v-btn icon class="close-btn" @click="closeD()">
                <icon name="circle-close" />
              </v-btn>
            </div>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-row>
              <v-col cols="12" v-if="isSubmitted">
                <v-stepper alt-labels class="elevation-0">
                  <v-stepper-header>
                    <v-stepper-step
                      step="1"
                      class="pa-5"
                      :complete="assessed_by_status == 2 ? true : false"
                      :rules="[() => assessed_by_status != 3]"
                      color="#6DB249"
                    >
                      <div style="width: 200px" class="text-center">
                        {{ assessed_by }}<br />
                        <small>Assessed By</small>
                      </div>
                    </v-stepper-step>
                  </v-stepper-header>
                </v-stepper>
              </v-col>
              <v-col cols="8" class="flex-items mt-2">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @click="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" class="pt-2 px-4">
                <v-card class="dt-container" elevation="0" outlined>
                  <v-data-table
                    :expanded.sync="expanded"
                    :headers="tab != 3 ? headers : headers1"
                    :items="dataItem"
                    :items-per-page="-1"
                    :item-class="setPendingClass"
                    show-expand
                  >
                    <template
                      v-if="tab != 3"
                      v-slot:[`item.suc_ind`]="{ item }"
                    >
                      <!-- {{ getItemSuccessIndicator(item) }} -->
                      {{ item.success_indicator }}
                    </template>
                    <template
                      v-if="tab != 3"
                      v-slot:[`item.efficiency`]="{ item }"
                    >
                      {{ item.eff_is_rated ? item.e_total : "Not to be Rated" }}
                    </template>
                    <template
                      v-if="tab != 3"
                      v-slot:[`item.quality`]="{ item }"
                    >
                      {{
                        item.qly_is_rated
                          ? (item.q_total != null ? item.q_total : 0) +
                            " | " +
                            item.q_avg
                          : "Not to be Rated"
                      }}
                    </template>
                    <template
                      v-if="tab != 3"
                      v-slot:[`item.timeliness`]="{ item }"
                    >
                      {{
                        item.timeliness_is_rated
                          ? (item.t_total != null ? item.t_total : 0) +
                            " | " +
                            item.t_avg
                          : "Not to be Rated"
                      }}
                    </template>
                    <template
                      v-if="tab == 3"
                      v-slot:[`item.success_indicator`]="{ item }"
                    >
                      {{ item.success_indicator }}
                    </template>
                    <template
                      v-if="tab == 3"
                      v-slot:[`item.supp_efficiency`]="{ item }"
                    >
                      {{
                        item.eff_is_rated ? item.efficiency : "Not to be Rated"
                      }}
                    </template>
                    <template
                      v-if="tab == 3"
                      v-slot:[`item.supp_quality`]="{ item }"
                    >
                      {{
                        item.qly_is_rated
                          ? item.quality
                            ? item.quality
                            : "" + " | " + item.q_avg
                            ? item.q_avg
                            : ""
                          : "Not to be Rated"
                      }}
                    </template>
                    <template
                      v-if="tab == 3"
                      v-slot:[`item.supp_timeliness`]="{ item }"
                    >
                      {{
                        item.timeliness_is_rated
                          ? item.timeliness
                            ? +item.timeliness
                            : "" + " | " + item.t_avg
                            ? item.t_avg
                            : ""
                          : "Not to be Rated"
                      }}
                    </template>

                    <template
                      v-if="tab == 3"
                      v-slot:[`item.actual_accomp`]="{ item }"
                    >
                      <!-- <div v-if="item.func_type == 2"></div> -->
                      <div v-if="item.func_type == 2">
                        <div v-for="(i, idx) in item.intervening" :key="idx">
                          {{ i.actual_accom }}
                        </div>
                      </div>
                    </template>

                    <template v-slot:expanded-item="{ headers, item }">
                      <td :colspan="headers.length" class="pa-4">
                        <table id="tbl_expanded">
                          <tr>
                            <th
                              class="text-caption font-weight-bold"
                              :colspan="e_span"
                              style="width: 33%"
                            >
                              Efficiency
                            </th>
                            <th
                              class="text-caption font-weight-bold"
                              :colspan="qt_span"
                              style="width: 33%"
                            >
                              Quality
                            </th>
                            <th
                              class="text-caption font-weight-bold"
                              :colspan="qt_span"
                              style="width: 33%"
                            >
                              Timeliness
                            </th>
                          </tr>
                          <tr>
                            <td
                              v-for="(ii, i) in expandHeaders"
                              :key="i"
                              align="center"
                              class="text-caption font-weight-bold"
                            >
                              {{ ii }}
                            </td>
                          </tr>

                          <tbody>
                            <tr v-if="tab != 3">
                              <td
                                v-for="(summary, i) in item.mporSummary"
                                :key="i"
                                :colspan="summary.colspan"
                                align="center"
                                class="text-caption"
                              >
                                {{ summary.value }}
                              </td>
                            </tr>

                            <tr v-if="tab == 3">
                              <td
                                v-for="(summary, i) in item.supportSummary"
                                :key="i"
                                :colspan="summary.colspan"
                                align="center"
                                class="text-caption"
                              >
                                {{ summary.value }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                      <v-btn
                        v-if="
                          isSubmitted &&
                            assessed_by_status == 3 &&
                            (tab != 3
                              ? hasUnOpennedRemarks(
                                  item.summary_pendingRemarks,
                                ) > 0
                              : false)
                        "
                        x-small
                        class="my-1"
                        @click="showPendingRemarks(item.summary_pendingRemarks)"
                        outlined
                        color="primary"
                        block
                        >Show Remarks</v-btn
                      >
                    </template>
                  </v-data-table>
                </v-card></v-col
              >
            </v-row>
            <v-row v-if="isSubmitted && assessed_by_status == 2" class="mt-4">
              <v-col cols="12">
                <v-divider class="mb-4"></v-divider>

                <div class="global-comment-card">
                  <div class="global-comment-header">
                    <div class="global-comment-icon">
                      <v-icon color="#147452">
                        mdi-message-text-outline
                      </v-icon>
                    </div>

                    <div>
                      <div class="global-comment-title">
                        Observation and Remarks
                      </div>

                      <div class="global-comment-subtitle">
                        Feedback, observations, and recommendations from the
                        evaluator
                      </div>
                    </div>
                  </div>

                  <div class="global-comment-content">
                    {{ summary.comments || "No remarks provided." }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-end">
            <v-card-text class="pa-1 mr-3 mt-8 d-flex justify-end">
              <v-btn
                class="btn-print"
                @click="printSummary()"
                v-if="!shouldSubmit()"
              >
                Print
              </v-btn>
              <v-spacer></v-spacer>
              <!-- <v-btn
                v-if="shouldSubmit()"
                color="#519043"
                class="btn-save"
                @click="submitSummary()"
              >
                Submit
              </v-btn> -->
            </v-card-text>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="confirmSubmitDialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="submit-icon">
            <icon name="circle-check" />
          </div>

          <div class="delete-title">Submit for Approval?</div>

          <div class="delete-description">
            Are you sure you want to submit this
            <strong>Summary for Approval</strong>?
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            :disabled="confirmBtnLoading"
            @click="cancelConfirm()"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            color="#147452"
            depressed
            class="btn-save"
            :loading="confirmBtnLoading"
            :disabled="confirmBtnLoading"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <MPOROutputDialog :data="mporData1" /> -->
    <ViewRemarksTimelineDialog
      :data="pendingList"
      :viewFrom="'Owner'"
      v-on:closeRemarksTimeline="initialize()"
    />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import ViewRemarksTimelineDialog from "../Views/ViewRemarksTimelineDialog.vue";
import icon from "@/assets/icon.vue";
export default {
  components: {
    ViewRemarksTimelineDialog,
    icon,
    // MPOROutputDialog: () => import("../Forms/MPOROutputDialog.vue"),
  },
  props: {
    data: null,
  },
  data() {
    return {
      summary: null,
      remarksData: [],
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      assesed_by_status: null,
      action: null,
      isloading: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      options: {},
      period: null,
      expanded: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
      ],
      cfSpData: null,
      mporData1: null,
      ipcr: null,
      expandHeaders: [],
      dataItem: [],
      monthsList: [],
      e_span: null,
      qt_span: null,
      monthSelection1: [
        {
          id: 1,
          name: "Jan",
        },
        {
          id: 2,
          name: "Feb",
        },
        {
          id: 3,
          name: "Mar",
        },
        {
          id: 4,
          name: "Apr",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "Jun",
        },
      ],
      monthSelection2: [
        {
          id: 7,
          name: "Jul",
        },
        {
          id: 8,
          name: "Aug",
        },
        {
          id: 9,
          name: "Sep",
        },
        {
          id: 10,
          name: "Oct",
        },
        {
          id: 11,
          name: "Nov",
        },
        {
          id: 12,
          name: "Dec",
        },
      ],
      monthSelection3: [
        {
          id: 1,
          name: "Jan",
        },
        {
          id: 2,
          name: "Feb",
        },
        {
          id: 3,
          name: "Mar",
        },
        {
          id: 4,
          name: "Apr",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "Jun",
        },
        {
          id: 7,
          name: "Jul",
        },
        {
          id: 8,
          name: "Aug",
        },
        {
          id: 9,
          name: "Sep",
        },
        {
          id: 10,
          name: "Oct",
        },
        {
          id: 11,
          name: "Nov",
        },
        {
          id: 12,
          name: "Dec",
        },
      ],
      monthRange: null,
      headers: [
        {
          text: "Major Function Output",
          value: "mfo",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "suc_ind",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "E Total",
          value: "efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q Total | Avg",
          value: "quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T Total | Avg",
          value: "timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
          width: 100,
          valign: "center",
          sortable: false,
        },
      ],
      headers1: [
        {
          text: "MFO",
          value: "type",
          align: "start",
          valign: "start",
          width: 200,
          sortable: false,
        },
        {
          text: "Success Indicators",
          value: "success_indicator",
          align: "start",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accomp",
          align: "start",
          valign: "center",
          width: 200,
          sortable: false,
        },
        {
          text: "E Total",
          value: "supp_efficiency",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Q Total | Avg",
          value: "supp_quality",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "T Total | Avg",
          value: "supp_timeliness",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Remarks",
          value: "remarks",
          align: "center",
          valign: "center",
          width: 200,
          sortable: false,
        },
      ],
      pendingList: [],
    };
  },

  watch: {
    data: {
      handler(data) {
        // console.log("Data Summary", data);
        this.dialog = true;
        this.activeTab = { id: 1, name: "Core Functions" };
        this.expandHeaders = [];
        this.tab = 1;
        this.period = data.period;
        this.ipcr = data;
        this.loadMonthList(data.periodFrom, data.periodTo, data.year);

        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  computed: {
    getIsQualifiedToSubmit() {
      let isQualifiedToSubmit = false;
      // if (this.ipcr) {
      //   if (this.ipcr[0].mpor && this.ipcr[0].mpor.length > 0) {
      //     let mpor = this.ipcr[0].mpor;
      //     let mporArr = [];
      //     for (let j = 0; j < mpor.length; j++) {
      //       mporArr.push(mpor[j].head_approval_status);
      //     }

      //     if (mporArr.includes(1) || mporArr.includes(3)) {
      //       isQualifiedToSubmit = false;
      //     } else {
      //       isQualifiedToSubmit = true;
      //     }
      //   } else {
      //     isQualifiedToSubmit = false;
      //   }
      // } else {
      //   isQualifiedToSubmit = false;
      // }
      return isQualifiedToSubmit;
    },
  },
  mounted() {
    this.eventHub.$on("closeMPOROutputDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeMPOROutputDialog");
  },
  methods: {
    loadMonthList(from, to, year) {
      let mnth = [
        {
          id: 1,
          name: "January",
        },
        {
          id: 2,
          name: "February",
        },
        {
          id: 3,
          name: "March",
        },
        {
          id: 4,
          name: "April",
        },
        {
          id: 5,
          name: "May",
        },
        {
          id: 6,
          name: "June",
        },
        {
          id: 7,
          name: "July",
        },
        {
          id: 8,
          name: "August",
        },
        {
          id: 9,
          name: "September",
        },
        {
          id: 10,
          name: "October",
        },
        {
          id: 11,
          name: "November",
        },
        {
          id: 12,
          name: "December",
        },
      ];
      this.monthsList = [];
      this.selectedMonth = null;

      for (let i = from - 1; i < to; i++) {
        this.monthsList.push(mnth[i]);
      }
      this.monthRange =
        this.monthsList[0].name +
        " to " +
        this.monthsList[this.monthsList.length - 1].name +
        " " +
        year;
      this.e_span = this.monthsList.length + 1;
      this.qt_span = this.monthsList.length + 2;
      this.loadExpandHeaders();
      // this.selectedMonth = this.monthsList[0].id;
      // console.log(this.monthsList);
    },

    initialize() {
      this.loading = true;
      this.loadRemarks(this.ipcr.id);
      if (this.tab != 3) {
        if (this.ipcr) {
          this.axiosCall(
            "/ipcr-target/getMyIPCRTargetMPORSummary/" +
              this.ipcr.id +
              "/" +
              this.tab,
            "GET",
          ).then((res) => {
            if (res) {
              // console.log("MPOR", res.data);
              this.dataItem = res.data.data;
              this.isSubmitted = res.data.summary.isSubmitted;
              this.summary = res.data.summary;
              this.loading = false;
            }
          });
        }
      } else {
        if (this.ipcr) {
          this.axiosCall(
            "/ipcr-target/getMyIPCRSupportSummary/" + this.ipcr.id,
            "GET",
          ).then((res) => {
            if (res) {
              // console.log("MPOR SUPPORT", res.data);
              this.dataItem = this.formatSupportFunctionData(res.data.data);
              // this.dataItem = res.data.data;
              this.isSubmitted = res.data.summary.isSubmitted;
              this.summary = res.data.summary;
              this.loading = false;
            }
          });
        }
      }

      //load signatory
      this.axiosCall(
        "/ipcr/getIPCRApproverNames/" + this.ipcr.id + "/SUMMARY",
        "GET",
      ).then((res) => {
        if (res) {
          // console.log("earas", res.data);
          this.assessed_by = this.toTitleCase(res.data.assessed_by_name);
          this.assessed_by_status = res.data.assesed_by_status;
          // this.final_rating_by = this.toTitleCase(
          //   res.data.final_rating_by_name
          // );
          // this.final_rating_by_status = res.data.final_rating_by_status;
        }
      });
    },

    setPendingClass(item) {
      if (this.assessed_by_status == 3) {
        if (this.tab != 3) {
          let list = item.summary_pendingRemarks;
          let has = false;
          if (list) {
            for (let i = 0; i < list.length; i++) {
              if (list[i].isOpenned == 0) {
                has = true;
                break;
              }
            }
            if (has) {
              return "red lighten-4";
            }
          }
          return "";
        }
      }
      return "";
    },

    hasUnOpennedRemarks(list) {
      if (list && list.length > 0) {
        let has = false;
        for (let i = 0; i < list.length; i++) {
          if (list[i].isOpenned == 0) {
            has = true;
            break;
          }
        }
        if (has) {
          return has;
        } else {
          if (this.assessed_by_status != 2 && this.isSubmitted) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    showPendingRemarks(item) {
      this.pendingList = [];
      setTimeout(() => {
        this.pendingList = item;
      }, 100);
    },

    formatSupportFunctionData(data) {
      let toReturn = [];
      let intervening = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].func_type != 2) {
          toReturn.push(data[i]);
        } else {
          intervening.push(data[i]);
        }
      }

      let intervening_ids = [];
      for (let i = 0; i < intervening.length; i++) {
        intervening_ids.push(intervening[i].id);
      }
      if (intervening.length > 0) {
        toReturn.push({
          id: intervening[0].id,
          type: "Intervening Function",
          func_type: 2,
          success_indicator: "Involved in Committee/s of the College",
          eff_is_rated: 1,
          qly_is_rated: 1,
          timeliness_is_rated: 1,
          efficiency: intervening[0].efficiency,
          timeliness: intervening[0].timeliness,
          quality: intervening[0].quality,
          supportSummary: intervening[0].supportSummary,
          intervening,
          intervening_ids,
        });
      }

      return toReturn;
    },
    submitSummary() {
      this.confirmSubmitDialog = true;
    },
    changeMPOR() {
      this.initialize();
    },
    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/IPCR_SUMMARY", "GET").then(
          (res) => {
            if (res.data) {
              // console.log("remarks", res.data);
              this.remarksData = res.data;
            }
          },
        );
      }
    },

    shouldSubmit() {
      if (this.isSubmitted == 0) {
        return true;
      } else {
        if (this.assessed_by_status == 1 || this.assessed_by_status == 2) {
          return false;
        } else {
          return true;
        }
      }
    },
    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },
    confirmSubmit() {
      this.confirmBtnLoading = true;
      // this.isSubmitLoading = true;
      this.axiosCall("/ipcr/submitMySummary/" + this.ipcr.id, "PATCH").then(
        (res) => {
          if (res.data.status == 200) {
            this.confirmBtnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        },
      );
    },

    loadExpandHeaders() {
      this.expandHeaders = [];
      if (this.tab != 3) {
        for (let i = 0; i < 3; i++) {
          this.e_span = this.monthsList.length + 1;
          this.qt_span = this.monthsList.length + 2;
          for (let j = 0; j < this.monthsList.length; j++) {
            this.expandHeaders.push(this.monthsList[j].name);
          }
          if (i == 0) {
            this.expandHeaders.push("Total");
          } else if (i > 0) {
            this.expandHeaders.push("Total");
            this.expandHeaders.push("AVE");
          }
          // if (period == 1) {
          //   this.e_span = this.monthSelection1.length + 1;
          //   this.qt_span = this.monthSelection1.length + 2;
          //   for (let j = 0; j < this.monthSelection1.length; j++) {
          //     this.expandHeaders.push(this.monthSelection1[j].name);
          //   }
          //   if (i == 0) {
          //     this.expandHeaders.push("Total");
          //   } else if (i > 0) {
          //     this.expandHeaders.push("Total");
          //     this.expandHeaders.push("AVE");
          //   }
          // } else if (period == 2) {
          //   this.e_span = this.monthSelection2.length + 1;
          //   this.qt_span = this.monthSelection2.length + 2;
          //   for (let j = 0; j < this.monthSelection2.length; j++) {
          //     this.expandHeaders.push(this.monthSelection2[j].name);
          //   }
          //   if (i == 0) {
          //     this.expandHeaders.push("Total");
          //   } else if (i > 0) {
          //     this.expandHeaders.push("Total");
          //     this.expandHeaders.push("AVE");
          //   }
          // } else if (period == 3) {
          //   this.e_span = this.monthSelection3.length + 1;
          //   this.qt_span = this.monthSelection3.length + 2;
          //   for (let j = 0; j < this.monthSelection3.length; j++) {
          //     this.expandHeaders.push(this.monthSelection3[j].name);
          //   }
          //   if (i == 0) {
          //     this.expandHeaders.push("Total");
          //   } else if (i > 0) {
          //     this.expandHeaders.push("Total");
          //     this.expandHeaders.push("AVE");
          //   }
          // }
        }
      } else {
        for (let i = 0; i < 3; i++) {
          this.e_span = 1;
          this.qt_span = 2;
          if (i == 0) {
            this.expandHeaders.push("Total");
          } else if (i > 0) {
            this.expandHeaders.push("Total");
            this.expandHeaders.push("AVE");
          }
          // if (period == 1) {
          //   if (i == 0) {
          //     this.expandHeaders.push("Total");
          //   } else if (i > 0) {
          //     this.expandHeaders.push("Total");
          //     this.expandHeaders.push("AVE");
          //   }
          // } else if (period == 2) {
          //   if (i == 0) {
          //     this.expandHeaders.push("Total");
          //   } else if (i > 0) {
          //     this.expandHeaders.push("Total");
          //     this.expandHeaders.push("AVE");
          //   }
          // } else if (period == 3) {
          //   if (i == 0) {
          //     this.expandHeaders.push("Total");
          //   } else if (i > 0) {
          //     this.expandHeaders.push("Total");
          //     this.expandHeaders.push("AVE");
          //   }
          // }
        }
      }
      // console.log(this.expandHeaders);
    },

    getItemSuccessIndicator(item) {
      return item.efficiency_type == "percentage"
        ? item.efficiency +
            "%" +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness
        : item.efficiency +
            " " +
            item.mfo +
            " " +
            item.quality +
            " " +
            item.timeliness;
    },
    getTotal(field, item) {
      if (item) {
        let i = item.mpor;

        if (field == "E") {
          let total = 0;
          if (item.eff_is_rated) {
            total += i ? (i.e_w1 ? i.e_w1 : 0) : "";
            total += i ? (i.e_w1 ? i.e_w2 : 0) : "";
            total += i ? (i.e_w1 ? i.e_w3 : 0) : "";
            total += i ? (i.e_w1 ? i.e_w4 : 0) : "";
            return total;
          } else {
            return "Not to be Rated";
          }
        } else if (field == "Q") {
          let total = 0;
          if (item.qly_is_rated) {
            total += i ? (i.q_w1 ? i.q_w1 : 0) : "";
            total += i ? (i.q_w1 ? i.q_w2 : 0) : "";
            total += i ? (i.q_w1 ? i.q_w3 : 0) : "";
            total += i ? (i.q_w1 ? i.q_w4 : 0) : "";
            return total;
          } else {
            return "Not to be Rated";
          }
        } else if (field == "T") {
          let total = 0;
          if (item.timeliness_is_rated) {
            total += i ? (i.t_w1 ? i.t_w1 : 0) : "";
            total += i ? (i.t_w1 ? i.t_w2 : 0) : "";
            total += i ? (i.t_w1 ? i.t_w3 : 0) : "";
            total += i ? (i.t_w1 ? i.t_w4 : 0) : "";
            return total;
          } else {
            return "Not to be Rated";
          }
        }
      }
    },
    closeD() {
      this.eventHub.$emit("closeMPORSummaryDialog", false);
      this.confirmSubmitDialog = false;
      this.dialog = false;
    },

    update(item) {
      console.log(item);
      this.mporData1 = item;
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.loadExpandHeaders();
      this.initialize();
    },
    printSummary() {
      // alert(this.data.id);
      console.log(this.data);
      let url;
      if (this.data.isFaculty == 0) {
        url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/generateIPCRForm/SUMMARY/" +
          this.data.id;
      } else {
        url =
          process.env.VUE_APP_SERVER +
          "/pdf-generator/generateIPCRForm/SUMMARY/" +
          this.data.id;
      }

      let token = localStorage.getItem("token");
      this.isLoading = true;
      const tab = window.open("about:blank");
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
#tbl_expanded {
  border-collapse: collapse;
  width: 100%;
  padding: 5px;
}
#tbl_expanded table,
#tbl_expanded th,
#tbl_expanded td {
  border: 2px solid grey;
}
</style>
